import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClinicItemJSON } from '../common/models/server-response/clinic-item-json.model';
import { EntOfficeListItemJSON } from '../common/models/server-response/ent-office-list-item-json.model';
import { UserListItemJSON } from '../common/models/server-response/user-list-item-json.model';
import { CreateUserItem } from '../common/models/users-data/create-user-item.model';
import { EditUserPropertiesItem } from '../common/models/users-data/edit-user-properties-item.model';
import { ApiService } from './api.service';
import { ClinicLinksObjectJSON } from '../common/models/server-response/clinic-links-object-json.model';
import { CountryId } from 'src/common-panel/constants/country-configs.constants';

@Injectable({
  providedIn: 'root'
})
export class RequestsService
{

  constructor(private apiService: ApiService) { }


  getUserList(): Observable<UserListItemJSON[]>
  {
    const params = new HttpParams().set('role', 'ANY');
    return this.apiService.get(`/api/v1/wr/admin/users`, params);
  }

  loadClinicListByCountry(countryId: CountryId): Observable<ClinicItemJSON[]>
  {
    const params = new HttpParams().set('countryId', countryId);
    return this.apiService.get(`/api/v1/wr/admin/shops`, params);
  }

  loadEntOfficeListByCountry(countryId: CountryId): Observable<EntOfficeListItemJSON[]>
  {
    const params = new HttpParams().set('countryId', countryId);
    return this.apiService.get(`/api/v1/wr/admin/offices`, params);
  }

  createUser(currentUser: CreateUserItem): Observable<{ id: string, surname: string, givenName: string }>
  {
    return this.apiService.post(`/api/v1/wr/admin/user`, currentUser);
  }

  editUser(userId: string, properties: EditUserPropertiesItem): Observable<any>
  {
    const params = new HttpParams().set('userId', userId);
    return this.apiService.patch(`/api/v1/wr/admin/user`, params, properties);
  }

  sendInvitation(userId: string): Observable<any>
  {
    const params = new HttpParams().set('userId', userId);
    return this.apiService.post(`/api/v1/wr/admin/sendInvite`, {}, params);
  }

  changeUserStatus(userId: string, accountEnabled: boolean): Observable<any>
  {
    const params = new HttpParams().set('userId', userId).set('accountEnabled', accountEnabled);
    return this.apiService.patch(`/api/v1/wr/admin/userStatus`, params);
  }

  deleteUser(userId: string): Observable<any>
  {
    const params = new HttpParams().set('userId', userId);
    return this.apiService.delete(`/api/v1/wr/admin/user`, params);
  }

  resetUserPassword(userId: string): Observable<any>
  {
    const params = new HttpParams().set('userId', userId);
    return this.apiService.post(`/api/v1/wr/admin/user`, params);
  }

  getClinicLists(userIds: string[]): Observable<ClinicLinksObjectJSON[]>
  {
    return this.apiService.post(`/api/v1/wr/shoplink/getManyLinks`, userIds);
  }

  getClinicList(userId: string): Observable<ClinicLinksObjectJSON>
  {
    const params = new HttpParams().set('userId', userId);
    return this.apiService.get(`/api/v1/wr/shoplink/getLinks`, params);
  }

  setClinicList(userId: string, clinics: string[]): Observable<any>
  {
    const params = new HttpParams().set('userId', userId);
    return this.apiService.post(`/api/v1/wr/shoplink/replaceLinks`, clinics, params);
  }
}
